export default "__VITE_ASSET__peUFbf_S__"